import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Ng2BootstrapModule } from "ngx-bootstrap";
import { AppComponent } from './app.component';
import {RouterModule, Routes} from "@angular/router";
import {LoginComponent} from "./components/login/login.component";
import {DashComponent} from "./components/dashboard/dashboard.component";
import {ReportsComponent} from "./components/reports/reports.component";
import {MachinesComponent} from "./components/machines/machines.component";
import {MachineEditComponent} from "./components/machine-edit/machine-edit.component";
import {FleetsComponent} from "./components/fleets/fleets.component";
import {UsersComponent} from "./components/users/users.component";
import {CreateUserComponent, SelectedPipe} from "./components/create-user/create-user.component";
import {UserDetailComponent} from "./components/user-detail/user-detail.component";
import {FormsModule} from "@angular/forms";
import {UserInfoComponent} from "./components/user-info/user-info.component";
import {MachineListComponent} from "./components/machine-list/machine-list.component";
import {DatepickerWindow} from "./components/datepicker-window/datepicker-window.component";
import { MyDatePickerModule } from 'mydatepicker';
import { AngularDateTimePickerModule } from 'angular2-datetimepicker';
import {MachineReportsComponent} from "./components/machine-reports/machine-reports.component";
import {FleetReportsComponent} from "./components/fleet-reports/fleet-reports.component";
import {NavTabsComponent} from "./components/nav-tabs/nav-tabs.component";
import {UserListComponent} from "./components/user-list/user-list.component";
import {UiSwitchModule} from "ngx-ui-switch";
import {UserService} from "./services/user.service";
import {AccountService} from "./services/account.service";
import {AlertService} from "./services/alerts.service";
import {MachineService} from "./services/machine.service";
import {HttpService} from "./services/http.service";
import {ConnectionBackend, Http, HttpModule} from "@angular/http";
import {ToastModule, ToastOptions, ToastsManager} from "ng2-toastr";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ReportsService} from "./services/reports.service";
import {HeaderComponent} from "./components/header/header.component";
import {GooglePlaceModule} from 'ng2-google-place-autocomplete';
import {Ng2FabSpeedDialModule} from "ng2-fab-speed-dial";
import {MachineCreateComponent} from "./components/machine-create/machine-create.component";
import {AccountsComponent} from "./components/accounts/accounts.component";
import {AccountListComponent} from "./components/account-list/account-list.component";
import {AccountCreateComponent} from "./components/account-create/account-create.component";
import {ForgotPasswordComponent} from "./components/forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./components/reset-password/reset-password.component";
import { HistorySearchComponent } from "./components/history-search/history-search.component";
import { TabsModule, TooltipModule } from 'ngx-bootstrap';

export const routes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'dashboard', component: DashComponent },
    { path: 'reports', component: ReportsComponent },
    { path: 'machines', component: MachinesComponent },
    { path: 'machines/:id/:tab', component: MachineEditComponent },
    { path: 'fleets', component: FleetsComponent },
    { path: 'users', component: UsersComponent },
    { path: 'create-user', component: CreateUserComponent },
    { path: 'machine-create', component: MachineCreateComponent },
    { path: 'users/:id', component: UserDetailComponent },
    { path: 'accounts', component: AccountsComponent },
    { path: 'create-account', component: AccountCreateComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: '', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        DashComponent,
        ReportsComponent,
        MachinesComponent,
        MachineEditComponent,
        FleetsComponent,
        UsersComponent,
        CreateUserComponent,
        UserDetailComponent,
        MachineCreateComponent,
        MachineListComponent,
        UserInfoComponent,
        DatepickerWindow,
        MachineReportsComponent,
        FleetReportsComponent,
        NavTabsComponent,
        UserListComponent,
        SelectedPipe,
        HeaderComponent,
        AccountsComponent,
        AccountListComponent,
        AccountCreateComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        HistorySearchComponent
    ],
    imports: [
        RouterModule.forRoot(
            routes,
            { enableTracing: false } // <-- debugging purposes only
        ),
        AngularDateTimePickerModule,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        GooglePlaceModule,
        HttpModule,
        MyDatePickerModule,
        Ng2BootstrapModule.forRoot(),
        Ng2FabSpeedDialModule,
        ToastModule,
        UiSwitchModule,
        TabsModule.forRoot(),
        TooltipModule.forRoot()
    ],
    providers: [
        CookieService,
        UserService,
        AccountService,
        AlertService,
        MachineService,
        HttpService,
        ToastsManager,
        ReportsService,
        ToastOptions
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts